import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { selectProfileData } from '@pages/profile/store/selectors';
import { useSelector } from 'react-redux';
import { Avatar } from '@efexteam/components';
import HeaderStyles from './Header.style';
import { logoEfexInvoice } from '@/assets';

const Header = ({ onClose }: { onClose: () => void }) => {
  const USER_PROFILE = useSelector(selectProfileData);
  const { name, lastName } = USER_PROFILE?.naturalPerson || {};

  const fullName = `${name} ${lastName}`;

  return (
    <div className={HeaderStyles.wrapper}>
      <div className={HeaderStyles.avatarWrapper}>
        <img src={logoEfexInvoice} alt="Efex Logo" />
        <Avatar showLabel username={fullName} size="md" />
      </div>
      <IconButton onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </div>
  );
};

export default Header;
